import { arrayToEntityDict, userSlimId, type UserCoursePerformance, type UserSlim } from '@webapp2/shared/model'
import { postGetBody } from '@webapp2/shared/services/api'
import { connectSignalr } from '@webapp2/shared/services/signalr'
import { updateByTypes as adminUpdateByTypes, type AdminEntityType } from '../admin/services/admin-entity-service'
import { ensureUsersForMultiplayerSessions } from '../admin/services/admin-user-service'
import { adminState } from '../admin/state'
import { config } from '../main'
import { state, type MultiplayerSession } from '../state'
import { cache } from './cache'
import { handleEntitiesUpdated, updateByTypes } from './entity-service'

export function initialize() {
  return connectSignalr(config.signalrUrl, {
    entitiesUpdated: handleEntitiesUpdated,
    adminEntitiesSlimUpdated: handleAdminEntitiesSlimUpdated,
    adminEntitiesUpdated: adminUpdateByTypes,
    adminEntitiesUpdatedWithIds: handleAdminEntitiesUpdatedWithIds,
    userCoursePerformanceUpdated: handleUserCoursePerformanceUpdated,
    userAssignmentStatusUpdated: handleUserAssignmentStatusUpdated
  })
}

async function handleAdminEntitiesSlimUpdated(types: string[]) {
  // TODO: fix type casing across webapp2 - should be Pascal
  const adminEntityTypes = types.map(x => x + 'Slim') as AdminEntityType[]
  await adminUpdateByTypes(adminEntityTypes)
}

function handleAdminEntitiesUpdatedWithIds(entitiesUpdated: EntitiesUpdated[]) {
  const tasks = entitiesUpdated.map(async ({ type, ids }) => {
    if (type === 'MultiplayerSession') {
      const idsToLoad = Object.keys(adminState.multiplayerSessions).filter(x => ids.includes(x))
      if (idsToLoad.length === 0) {
        return
      }
      const response = await postGetBody<MultiplayerSession[]>('admin/documents-by-id', {
        type: 'MultiplayerSession',
        ids: idsToLoad
      })
      if (response) {
        adminState.multiplayerSessions = { ...adminState.multiplayerSessions, ...arrayToEntityDict(response) }
        await ensureUsersForMultiplayerSessions(response)
      }
    } else if (type === 'User') {
      const response = await postGetBody<UserSlim[]>('admin/documents-by-id', {
        type: 'UserSlim',
        ids: ids.map(userSlimId)
      })
      if (response) {
        adminState.userSlims = { ...adminState.userSlims, ...arrayToEntityDict(response) }
      }
    }
  })
  return Promise.all(tasks)
}

async function handleUserCoursePerformanceUpdated(userCoursePerformance: UserCoursePerformance) {
  await cache.set(userCoursePerformance.id, userCoursePerformance)
  state.userCoursePerformances[userCoursePerformance.id] = userCoursePerformance
}

async function handleUserAssignmentStatusUpdated() {
  await updateByTypes(['userAssignmentStatus', 'assignment'])
}

type EntitiesUpdated = {
  type: string
  ids: string[]
}
